module.exports = __webpack_public_path__ + "img/ydym.4e6ccac1.png";